'use strict';

module.exports = require('./components/ReadMoreReact');


/*****************
 ** WEBPACK FOOTER
 ** ./~/read-more-react/dist/index.js
 ** module id = 1260
 ** module chunks = 0 1 4 5
 **/